import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import EncuentraCafe from "@/components/EncuentraCafe";
import ChoiceBlock from "@/components/ChoiceBlock";
import RitualOrigin from "@/components/RitualOrigin";
import Academia from "@/components/Academia";
import B2BForm from "@/components/B2BForm";
import Story from "@/components/Story";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { useLang } from "@/i18n";
import { itemListLd, organizationLd, websiteLd } from "@/lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Home = () => {
  const { hash } = useLocation();
  const { lang, t } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((r) => setProducts(r.data || []))
      .catch(() => {});
  }, []);

  // arriving from another page with /#coffees, /#hosteleria, ...
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 220);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div className="bg-[#F5F1E8] overflow-x-hidden">
      <Seo
        title={t.seo.home.title}
        description={t.seo.home.description}
        path="/"
        lang={lang}
        jsonLd={[
          organizationLd(),
          websiteLd(),
          ...(products.length ? [itemListLd(products)] : []),
        ]}
      />
      <Navbar />
      <Hero />
      <EncuentraCafe />
      <ChoiceBlock />
      <RitualOrigin />
      <Academia />
      <B2BForm />
      <Story />
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Home;
